const typeLabels = {
  roles: 'Role',
  permission: 'Permissions',
  orderedParts: 'Ordered part',
  warehouseParts: 'Warehouse part',
  coOrder: 'CO order',
};

const fieldLabels = {
  name: 'Name',
  order_status: 'Order status',
  ordered_part_qty_in_order: 'Quantity in order',
  part_whs_total_qty: 'Total quantity',
  part_whs_available_qty: 'Available quantity',
  part_whs_reserved_qty: 'Reserved quantity',
  permissions: 'Permissions',
};

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const displayField = (field) => fieldLabels[field]
  || field.replace(/_/g, ' ').replace(/^./, (letter) => letter.toUpperCase());

export const getLogPresentation = ({ type, action, data }) => {
  const payload = data && typeof data === 'object' ? data : {};
  const previous = payload.previous && typeof payload.previous === 'object' ? payload.previous : {};
  const requested = payload.req && typeof payload.req === 'object' ? payload.req : {};
  const result = payload.result && typeof payload.result === 'object' ? payload.result : {};
  const current = Object.keys(requested).length ? requested : result;
  const fields = Object.keys(current).filter((field) => (
    !['id', '_id', 'type'].includes(field)
    && JSON.stringify(previous[field]) !== JSON.stringify(current[field])
  ));
  const changes = fields.map((field) => ({
    field,
    before: previous[field],
    after: current[field],
  }));
  /* eslint-disable no-underscore-dangle */
  const reference = previous._id || previous.id || requested._id || requested.id
    || result._id || result.id || previous.ordered_part_po || requested.ordered_part_po
    || previous.part_whs_id || requested.part_whs_id;
  /* eslint-enable no-underscore-dangle */
  const title = `${typeLabels[type] || type || 'Record'}${reference ? ` ${reference}` : ''}`;
  let summary = '';
  if (action === 'update' && changes.length) {
    const first = changes[0];
    summary = `${displayField(first.field)}: ${formatValue(first.before)} → ${formatValue(first.after)}`;
    if (changes.length > 1) summary += ` · +${changes.length - 1} more`;
  } else if (action === 'print') {
    summary = 'Label printed';
  } else if (action === 'create') {
    summary = 'Created';
  } else if (action === 'delete') {
    summary = 'Deleted';
  } else {
    summary = action || 'Event';
  }
  return { title, summary, changes };
};
